import { createSlice } from '@reduxjs/toolkit';

import { IOrder } from '../../types';

const initialState = {
  enabled: 0,
  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  orders: [] as IOrder[],
  initialLoading: true,
  isQueryLoading: false,
  qty_all: 0,
  qty_canceled: 0,
  qty_pending: 0,
  status: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders(state, { payload }) {
      state.enabled = payload.enabled;
      state.orders = payload.orders;
      state.qty_all = payload.qty_all;
      state.qty_canceled = payload.qty_canceled;
      state.qty_pending = payload.qty_pending;
      state.status = payload.status;
      state.initialLoading = payload.initialLoading;
    },
    setQueryLoading(state, { payload }) {
      state.isQueryLoading = payload.isQueryLoading;
    },
  },
});

export const { setOrders, setQueryLoading } = orderSlice.actions;
export default orderSlice.reducer;
